import React from 'react';
import Select from 'react-select';
import { RoleTypeEnum } from 'src/enums/roleTypeEnum';
import { SelectRole } from 'src/types/ViewModel/SelectRole';

type Props = {
    onChange: (ev: any) => void;
    roleList: RoleTypeEnum[];
    selectedRole: RoleTypeEnum | null;
};

const SelectRoleComponent: React.FC<Props> = (props) => {
    const mappedOptions = (): SelectRole[] => {
        const vList: SelectRole[] = props.roleList.map((v) => {
            return new SelectRole(v, v.toString());
        });
        return vList.sort((a, b) => a.label.localeCompare(b.label));
    };

    const mappedSelectedRole = (): SelectRole | null => {
        if (props.selectedRole) {
            return new SelectRole(props.selectedRole, props.selectedRole.toString());
        }
        return null;
    };

    const styles = {
        control: (css) => ({ ...css, display: 'inline-flex', width: '200px' }),
    };

    return (
        <Select
            className="select-container"
            value={mappedSelectedRole()}
            options={mappedOptions()}
            onChange={props.onChange}
            styles={styles}
            isSearchable={true}
        />
    );
};

export default SelectRoleComponent;
